export default "__VITE_ASSET__Cgt4j$wb__"